<mat-dialog-content style="display: flex; flex-direction: column;">

    <h2 mat-dialog-title style="margin: 0px;">Datum auswählen Account anlegen</h2>

    
    <div style="display: flex;">
        <mat-form-field>
            <input matInput [matDatepicker]="testDatePicker" placeholder="Testversion bis" [(ngModel)]="date">
            <mat-datepicker-toggle matSuffix [for]="testDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #testDatePicker ></mat-datepicker>
        </mat-form-field>
    </div>

    <mat-dialog-actions>
        <button mat-button color="warn" mat-dialog-close tabindex="-1">Abbrechen</button>
        <button mat-button color="accent" (click)="close()">Speichern</button>
    </mat-dialog-actions>